import { AgentClientFactory, CustomerClientFactory } from "client/customer/factory";
import { AccountClientWithoutFactory } from "@/client/aible/account/without_factory";
export class AccountClient {
    base;
    CACHE = {};
    AGENT_CACHE = {};
    withoutFactory;
    constructor(base) {
        this.base = base;
        this.withoutFactory = new AccountClientWithoutFactory(base);
    }
    getAccount(id) {
        return this.withoutFactory.getAccount(id);
    }
    getPresignedUrl(id, name) {
        return this.withoutFactory.getPresignedUrl(id, name);
    }
    getAccountExecutor(account) {
        return this.withoutFactory.getAccountExecutor(account);
    }
    getAppConfig() {
        return this.withoutFactory.getAppConfig();
    }
    getExecutor(id) {
        return this.withoutFactory.getExecutor(id);
    }
    getSTSToken(id) {
        return this.withoutFactory.getSTSToken(id);
    }
    /** Construct a client for making a customer cloud request */
    getAccountClient(account) {
        return this.withoutFactory.getAccountClient(account);
    }
    getCustomerClientFactory(id) {
        if (this.CACHE[id]) {
            return Promise.resolve(this.CACHE[id]);
        }
        return Promise.all([this.getAccount(id), this.getAppConfig()])
            .then(([account, config]) => this.getAccountClient(account).then((client) => new CustomerClientFactory(client, config, account, this.withoutFactory)))
            .then((factory) => (this.CACHE[id] = factory));
    }
    getAgentClientFactory(id) {
        if (this.AGENT_CACHE[id]) {
            return Promise.resolve(this.AGENT_CACHE[id]);
        }
        return this.getAccount(id)
            .then((account) => AgentClientFactory.create(account))
            .then((factory) => (this.AGENT_CACHE[id] = factory));
    }
    presignedGetRequest(account, url, name) {
        return this.withoutFactory.presignedGetRequest(account, url, name);
    }
    presignedPutRequest(account, url, data) {
        return this.withoutFactory.presignedPutRequest(account, url, data);
    }
}
